import {BrowserModule} from '@angular/platform-browser';
import {Component, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {HomeComponent} from './pages/home/home.component';
import {ServicesComponent} from './pages/services/services.component';
import {WorkComponent} from './pages/work-list/work-list.component';
import {WorkDetailComponent} from './pages/work-detail/work-detail.component';
import {TeamComponent} from './pages/team/team.component';
import {ContactComponent} from './pages/contact/contact.component';


export const ROUTES = [
  {
    path: '',
    name: 'Home',
    isHome: true,
    hidden: false,
    data: {title: 'Home', slug: 'home'},
    component: HomeComponent
  },
  {
    path: 'services',
    name: 'Services',
    isHome: false,
    hidden: false,
    data: {title: 'Services', slug: 'services'},
    component: ServicesComponent
  },
  {
    path: 'work',
    name: 'Work',
    isHome: false,
    hidden: false,
    data: {title: 'Work', slug: 'works'},
    component: WorkComponent
  },
  {
    path: 'work/:slug',
    name: 'Work Detail',
    isHome: false,
    hidden: true,
    data: {title: 'Work', slug: 'work'},
    component: WorkDetailComponent
  },
  {
    path: 'team',
    name: 'Team',
    isHome: false,
    hidden: false,
    data: {title: 'Team', slug: 'team'},
    component: TeamComponent
  },
  {
    path: 'contact',
    name: 'Contact',
    isHome: false,
    hidden: false,
    data: {title: 'Contact', slug: 'contact'},
    component: ContactComponent
  }
];


@NgModule({
  imports: [RouterModule.forRoot(ROUTES)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/app-routing.module.ts